import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
/**
 * @author PKr
 */


import { Utils, SupplierAgreementConverter, jsonConversions, SupplierPriceRecalculationConverter, SupplierAgreementUpdateDTOConverter } from '@logio/common-be-fe';
import { Inject } from '@logio/typescript-ioc';
import { Map as IMap } from 'immutable';
import { CONSTANTS } from '../../../constants';
import { CRUTransportLayer } from '../CRUTransportLayer';
import api from '../../api';
import logger from '../../logger';
/** Network layer for SupplierAgreement */

export var SupplierAgreementLayer =
/*#__PURE__*/
function (_CRUTransportLayer) {
  _inherits(SupplierAgreementLayer, _CRUTransportLayer);

  function SupplierAgreementLayer() {
    var _this;

    _classCallCheck(this, SupplierAgreementLayer);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SupplierAgreementLayer).call(this, CONSTANTS.API.ENDPOINTS.SUPPLIER_AGREEMENTS));

    _this.partialUpdate = function (partialSupplierAgreements, sessionId) {
      return api(CONSTANTS.API.ENDPOINTS.SUPPLIER_AGREEMENT_UPDATE(sessionId)).post({
        supplierAgreements: partialSupplierAgreements.map(function (psa) {
          return _this.supplierAgreementUpdateDTOConverter.toDocument(psa, jsonConversions);
        })
      }, {
        responseType: 'json'
      }).then(function (response) {
        return (response.data.result || []).map(function (item) {
          return _this.getConverter().toObject(item, jsonConversions);
        });
      }).catch(function (error) {
        logger.error(error);
        return Promise.reject(error);
      });
    };

    return _this;
  }

  _createClass(SupplierAgreementLayer, [{
    key: "getConverter",
    value: function getConverter() {
      return this.converter;
    }
    /**
     * Returns recalculated prices for given range of supplier agreements
     * @param supplierAgreementsIds
     * @param sessionId
     */

  }, {
    key: "recalculatePurchasePrices",
    value: function recalculatePurchasePrices(supplierAgreementsIds, sessionId) {
      var _this2 = this;

      return api(CONSTANTS.API.ENDPOINTS.SUPPLIER_AGREEMENTS_RECALCULATE_PURCHASE_PRICES(sessionId)).post({
        supplierAgreementsIds: supplierAgreementsIds
      }, {
        responseType: 'json'
      }).then(function (response) {
        return (response.data.result || []).map(function (item) {
          return _this2.priceConverter.toObject(item, jsonConversions);
        });
      }).catch(function (error) {
        return Promise.reject(error);
      });
    }
  }, {
    key: "getByWindowItemId",
    value: function getByWindowItemId(windowId, windowItemIds) {
      var _this3 = this;

      return api(CONSTANTS.API.ENDPOINTS.SUPPLIER_AGREEMENTS_FILTER(windowId)).post({
        windowItemIds: windowItemIds
      }, {
        responseType: 'json'
      }).then(function (response) {
        var arr = [];
        (response.data.result || []).map(function (item) {
          arr.push(_this3.getConverter().toObject(item, jsonConversions));
        });
        return arr;
      }).catch(function (error) {
        return Promise.reject(error);
      });
    }
  }, {
    key: "createSupplierAgreements",
    value: function createSupplierAgreements(data, sessionId) {
      var _this4 = this;

      return api(CONSTANTS.API.ENDPOINTS.SUPPLIER_AGREEMENTS_CREATE(sessionId)).post(data, {
        responseType: 'json'
      }).then(function (response) {
        var arr = [];
        (response.data.result || []).map(function (item) {
          arr.push(_this4.getConverter().toObject(item, jsonConversions));
        });
        return arr;
      }).catch(function (error) {
        logger.error(error);
        return Promise.reject(error);
      });
    }
  }, {
    key: "filter",
    value: function filter(_filter, sessionId) {
      var _this5 = this;

      return api(CONSTANTS.API.ENDPOINTS.SUPPLIER_AGREEMENTS_FILTER(sessionId)).post(_filter, {
        responseType: 'json'
      }).then(function (response) {
        var arr = [];
        (response.data.result || []).map(function (item) {
          arr.push(_this5.getConverter().toObject(item, jsonConversions));
        });
        return arr;
      }).catch(function (error) {
        logger.error(error);
        return Promise.reject(error);
      });
    }
  }, {
    key: "delete",
    value: function _delete(supplierAgreementIds, sessionId) {
      return api(CONSTANTS.API.ENDPOINTS.SUPPLIER_AGREEMENTS_DELETE(sessionId)).delete({
        data: {
          supplierAgreementIds: supplierAgreementIds
        }
      }).then(function (response) {
        return response.data.result;
      }).catch(function (error) {
        logger.error(error);
        return Promise.reject(error);
      });
    }
    /**
     * <p>Reset purchase price for provided {@link SupplierAgreement} set of ids.</p>
     *
     * @param agreementIds Set of {@link SupplierAgreement} ids.
     * @param sessionId Session id.
     */

  }, {
    key: "promoPurchasePriceReset",
    value: function promoPurchasePriceReset(agreementIds, sessionId) {
      var _this6 = this;

      var apiConfig = {
        responseType: 'json'
      };
      return api(CONSTANTS.API.ENDPOINTS.SUPPLIER_AGREEMENTS_PROMO_PURCHASE_PRICE_RESET(sessionId)).post({
        supplierAgreementsIds: agreementIds.toArray()
      }, apiConfig).then(function (response) {
        var result = response.data.result;

        if (!Utils.isArray(result)) {
          return IMap();
        }

        return result.reduce(function (list, item) {
          var agreement = _this6.getConverter().toObject(item, jsonConversions);

          return list.set(agreement.id, agreement);
        }, IMap());
      }).catch(function (error) {
        logger.error(error);
        return Promise.reject(error);
      });
    }
  }]);

  return SupplierAgreementLayer;
}(CRUTransportLayer);

__decorate([Inject, __metadata("design:type", SupplierAgreementConverter)], SupplierAgreementLayer.prototype, "converter", void 0);

__decorate([Inject, __metadata("design:type", SupplierAgreementUpdateDTOConverter)], SupplierAgreementLayer.prototype, "supplierAgreementUpdateDTOConverter", void 0);

__decorate([Inject, __metadata("design:type", SupplierPriceRecalculationConverter)], SupplierAgreementLayer.prototype, "priceConverter", void 0);